import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const InteresHijo = () => {

    const { proyecto, setProyecto } = useProyecto();
    const {setPromptData, promptData} = useActividadesContext();    

    const handleInteresChange = (event: any) => {
        const { value } = event.target;
        setPromptData((prevData: any) => ({
            ...prevData,
            interes: value 
          }));
      };

    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >Interés del niño * </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> Describe un tema o propósito de interés para fomentar el aprendizaje.</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Ejemplo: Animales de la selva.'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.interes}
                onChange={handleInteresChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default InteresHijo;




